import { Avatar, Box, Divider, IconButton, InputBase, List, ListItem, ListItemAvatar, ListItemText, Menu, MenuItem, Paper, Typography } from '@mui/material'
import React, { useContext, useMemo, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { deleteMail } from '../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { deleteEmail } from '../../store/Slices/emailsSlice';
import DeleteMail from '../../components/tab/tabview/mail/DeleteMail';
import { useNavigate } from 'react-router-dom'
import { IoIosSearch } from "react-icons/io";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { IoAddSharp } from "react-icons/io5";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { RiDeleteBin5Line } from "react-icons/ri";
import { VscEye } from "react-icons/vsc";
import NewMail from '../components/modals/NewMail';
import ViewMAil from '../components/modals/ViewMAil';

export default function MailComponent() {
  const [open, setOpen] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [mailToDelete, setMailToDelete] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);
  const [mailToView, setMailToView] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useTranslation()
  const { emails = [] } = useSelector(state => state.email, shallowEqual);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const handleDeleteOpen = (mail) => {
    setMailToDelete(mail);
    setDeleteOpen(true);
  };

  const handleViewOpen = (mail) => {
    setMailToView(mail);
    setViewOpen(true);
  }

  const handleDelete = async () => {
    if (!mailToDelete) {
      console.error("No mail selected for deletion.");
      return;
    }

    const data = { id: mailToDelete.id };

    try {
      const response = await deleteMail(data);
      console.log("Response:", response);

      if (response.status === 200) {
        toast.success("Mail deleted successfully!", {
          duration: 2000,
          position: "top-right",
        });

        dispatch(deleteEmail(mailToDelete.id));

        setTimeout(() => {
          setDeleteOpen(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Error deleting mail:", error);
      toast.error("Failed to delete mail.");
    }
  };

  const filteredEmails = useMemo(() => {
    return emails.filter(
      (email) =>
        email.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
        email.senderName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [emails, searchQuery]);

  const handleMenuOpen = (event, email) => {
    setAnchorEl(event.currentTarget);
    setSelectedEmail(email);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedEmail(null);
  };

  return (
    <>
      {!open && !viewOpen && (
        <Box display="flex" flexDirection="column" height="100vh">
          <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
            <Box display="flex" alignItems="center">
              <IconButton onClick={() => navigate('/quote')}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
              <Typography fontSize={18} fontWeight={600} ml={1}>{t('inboxMail')}</Typography>
            </Box>
            <IoAddSharp style={{ fontSize: 20 }} onClick={() => setOpen(true)} />
          </Box>

          <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", px: 2, pt: 1 }}>
            <Paper elevation={0} sx={{ display: "flex", alignItems: "center", gap: 0.8, borderRadius: 2, px: 1.5, py: 0.5, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
              <IoIosSearch style={{ color: "gray", fontSize: 20, mr: 1 }} />
              <InputBase placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ flex: 1, fontSize: 14, }} />
            </Paper>
          </Box>
          <Box sx={{ flexGrow: 1, overflowY: 'auto', backgroundColor: darkMode ? "#151924" : "#fff" }}>
            <List sx={{ padding: 0 }}>
              {filteredEmails.map((email, index) => (
                <React.Fragment key={index}>
                  <ListItem alignItems="center"
                    secondaryAction={<IconButton edge="end" onClick={(e) => handleMenuOpen(e, email)}><MoreVertIcon /></IconButton>}>
                    <ListItemAvatar>
                      <Avatar><img src="/logo192.png" alt="logo" width={24} height={24} /></Avatar>
                    </ListItemAvatar>

                    <ListItemText
                      primary={<Typography variant="subtitle1" sx={{ fontWeight: 500, color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{email.subject}</Typography>}
                      secondary={<Typography variant="body2" color="text.secondary">Sender : {email.senderUsername}</Typography>}
                    />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          </Box>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} PaperProps={{ elevation: 3, sx: { minWidth: 130 } }} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
            <MenuItem onClick={() => { handleViewOpen(selectedEmail); handleMenuClose(); }}>
              <Box display="flex" alignItems="center" justifyContent='space-between' sx={{ width: '100%' }}>
                <Typography>View</Typography>
                <VscEye style={{ fontSize: 22 }} />
              </Box>
            </MenuItem>
            <MenuItem onClick={() => { handleDeleteOpen(selectedEmail); handleMenuClose(); }}>
              <Box display="flex" alignItems="center" justifyContent='space-between' sx={{ width: '100%' }}>
                <Typography>Delete</Typography>
                <RiDeleteBin5Line style={{ fontSize: 20 }} />
              </Box>
            </MenuItem>
          </Menu>
        </Box>)}
      {open && (
        <NewMail open={open} onClose={() => setOpen(false)} />
      )}
      <DeleteMail open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDelete={handleDelete} />
      {viewOpen && (<ViewMAil open={viewOpen} handleClose={() => setViewOpen(false)} mail={mailToView} />)}
    </>
  )
}
